import { Grid, Typography } from "@material-ui/core";
import { PublicPageHeader } from "../../../components/headers/header-public-page/header-public-page";
import { SelecionarEmpresaList } from "./components/selecionar-empresa-list/selecionar-empresa-list";
import { useStyles } from "./selecionar-empresa-styles";

const SelecionarEmpresaPage = () => {

    const classes = useStyles()

    return (
        <>
            <PublicPageHeader topOpacity="0.8" />
            <Grid className={classes.container}>
                <Grid className={classes.content}>
                    <Grid className={classes.infoContainer}>
                        <Typography className={classes.textTitle}>
                            Empresas
                        </Typography>
                        <Typography className={classes.textSubtitle}>
                            Escolha a empresa para prosseguir.
                        </Typography>
                        <SelecionarEmpresaList />
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default SelecionarEmpresaPage